/**
 * Drawer ID for the Routes Drawer
 * Used by useDrawer hook to control open/close state
 */
export const ROUTES_DRAWER_ID = 'routes-drawer';
